import { createI18n } from 'vue-i18n'
import enUS from './en-US.json'
import zhCN from './zh-CN.json'

//创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API
  locale: localStorage.getItem('language') || 'zh-CN', // 默认语言
  fallbackLocale: 'en-US', // 回退语言
  messages: {
    'en-US': enUS,
    'zh-CN': zhCN
  },
  // 全局配置
  datetimeFormats: {
    'en-US': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }
    },
    'zh-CN': {
      short: {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }
    }
  },
  numberFormats: {
    'en-US': {
      currency: {
        style: 'currency',
        currency: 'USD'
      }
    },
    'zh-CN': {
      currency: {
        style: 'currency',
        currency: 'CNY'
      }
    }
  }
})
export default i18n